import { Select, Radio } from 'antd'
import { WeaverQuery, getNodeLabel, getProjectData } from 'Services/WeaverUtils'
import { showActionsPage } from 'Components'
import moment from 'moment'
{ Option } = Select
{ Group } = Radio

STATUS = [{
  requiresRole: 'pms-invoerder'
  fromValues: ['concept']
  toValues: ['voorbereid']
}, {
  requiresRole: 'pms-invoerder'
  fromValues: ['afgekeurd']
  toValues: ['concept']
}, {
  requiresRole: 'pms-vrijgever'
  fromValues: ['voorbereid']
  toValues: ['afgekeurd']
},  {
  requiresRole: 'pms-vrijgever'
  fromValues: ['voorbereid']
  toValues: ['vrijgegeven']
},  {
  requiresRole: 'pms-vrijgever'
  fromValues: ['vrijgegeven']
  toValues: ['afgekeurd']
}]

STANDARD = [{
  requiresRole: 'pms-invoerder'
  fromValues: ['*']
  toValues: ['*']
  override: (form) ->
    status = form.getFieldValue('status')[0]
    status is 'vrijgegeven' or status is 'afgekeurd'
}]

STANDARD_CREATE = [{
  requiresRole: 'pms-invoerder'
  fromValues: ['*']
  toValues: ['*']
}]

Q = ->
  query = new Weaver.Query()
  query.str = -> JSON.stringify(query)
  query

export default {
  memberKey: 'rdf:type'
  nameKeys: [
    'identificatie'
    'name'
    'assetnum'
    'omschrijving'
    'naam'
    'tracedeelnummer'
    'titel'
    'rijstrooknummer'
    'betaalperiodeID'
    'referentieOG'
    'boetepuntcategorieNummer'
    'eisID'
    'faaldefintieTitel'
    'Verificatie-methode'
  ]
  groupings: [
    {
      id:    'stamdata'
      label: 'Stamdata'
      type: 'GROUP'
      data:
        children: [
          "tracedelen_realisatie"
          "betaalperioden"
        ]
    }
    {
      id:    'tracedeelafsluitingen'
      label: 'Tracedeelafsluitingen'
      type:  'GROUP'
      data:
        children: [
          "ta1"
          "ta2"
          "ta3"
        ]
    }
  ]

  queries: [
    {
      id: "tracedelen_realisatie"
      label: "Tracedelen Realisatiefase"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "tracedeel_realisatie").selectIn("Tracedeel").str()
    }
    {
      id: "betaalperioden"
      label: "Betaalperioden"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "betaalperiode").str()
    }

    {
      id: "ta1"
      label: "Alle Tracedeelafsluitingen"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "tracedeelafsluiting").selectOut('Gebeurtenis').selectOut("Tracedeel").selectOut("Oorzaak").selectOut("SnelheidOpRijstrook", "Snelheid").str()
    }

    {
      id: "ta2"
      label: "Preventieve Tracedeelafsluitingen"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "tracedeelafsluiting").hasRelationOut("Oorzaak", "preventieveAfsluiting").selectOut('Gebeurtenis').selectOut("Tracedeel").selectOut("SnelheidOpRijstrook", "Snelheid").str()
    }

    {
      id: "ta3"
      label: "Correctieve Tracedeelafsluitingen"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "tracedeelafsluiting").hasRelationOut("Oorzaak", "correctieveAfsluiting").selectOut('Gebeurtenis').selectOut("Tracedeel").selectOut("SnelheidOpRijstrook", "Snelheid").str()
    }

    {
      id: "geb"
      label: "Gebeurtenissen"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "gebeurtenis").selectIn('Gebeurtenis').str()
    }

    {
      id: "bp"
      label: "Boetepunten"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "boetepunten").selectOut('Gebeurtenis').selectOut('Betaalperiode').str()
    }

    {
      id: "wo"
      label: "Workorders"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "workorder").selectOut('Gebeurtenis').selectOut('Eis').str()
    }

    {
      id: "vkm"
      label: "Verkeersmaatregels"
      type: "QUERY"
      data:
        treeQuery: Q().hasRelationOut("rdf:type", "verkeersmaatregel").selectOut('Gebeurtenis').str()
    }

  ]
  getProjectSpecificActions: ({ activeNode, currentItem, data, props... }) ->
    if activeNode?._relations['rdf:type']?._records?[0]?
      [{
        key: 'edit-sequence'
        title: 'Edit sequence'
        onClick: ->
          nodeId = data.active.nodes[0]
          mode = 'edit'
          editPages = getProjectData().actionsPages.concat(getProjectData().editPages)
          conf = editPages
            .find(({ formSequence })->
              if formSequence?
                { onSave: { nodeClassName } } = formSequence
                nodeClassName is activeNode?.type.id()
            )
          showActionsPage({ conf..., nodeId, mode, title: 'Edit' })
        hidden: ->
          not (getProjectData()
            .actionsPages
            .find(({ formSequence })->
              if formSequence?
                { onSave: { nodeClassName } } = formSequence
                nodeClassName is activeNode?.type?.id()
            )? or getProjectData()
            .editPages
            .find(({ formSequence })->
              if formSequence?
                { onSave: { nodeClassName } } = formSequence
                nodeClassName is activeNode?.type?.id()
            )?)
      }]
    else
      []
  actionsPages: [{
    key: 'create-tracedeelafsluiting'
    title: 'Tracedeelafsluiting aanmaken'
    closeLabel: null
    component: 'sequenced_form'
    formSequence:
      createPermissions: STANDARD_CREATE
      onSave:
        confirmation: 'De tracedeelafsluiting is succesvol aangemaakt'
        nodeClassName: 'tracedeelafsluiting'
        nodeClassLabel: 'Tracedeelafsluiting'
        conditions: [{
          formField: 'verkeersstop'
          hasValue: true
          nodeAttr: 'vluchtstrookBeschikbaar'
          setValue: false
        }]
      queries: [{
        id: 'status'
        query:  -> Q().hasRelationOut('rdf:type', 'ClassificatieStatus').str()
      }, {
        id: 'tracedelen'
        query: -> Q().hasRelationOut('rdf:type', 'tracedeel_realisatie').str()
      }, {
        id: 'snelheid'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieSnelheid').str()
      }, {
        id: 'oorzaak'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieOorzaak').str()
      }, {
        id: 'gebeurtenis'
        query: -> Q().hasRelationOut('rdf:type', 'gebeurtenis').str()
      }, {
        id: 'rijstrookafsluiting'
        query: -> Q().hasRelationOut('rdf:type', 'tracedeelafsluiting').str()
      }]
      formFields: [{
        formItem: 'identificatie'
        formItemLabel: 'Identificatie'
        formItemType: 'string'
        config: { hidden: true, incrementationPrefix: 'TA_', type: 'increment_id', disabled: true }
        editPermissions: STANDARD
      }, {
        formItem: 'titel'
        formItemLabel: 'Titel'
        formItemType: 'string'
        formItemRules: [{ required: true, message: 'Titel is verplicht' }]
        editPermissions: STANDARD
      }, {
        formItem: 'duur'
        formItemLabel: 'Duur van de tracedeelafsluiting'
        formItemType: 'daterange'
        formItemRules: [{ required: true, message: 'Duur van de tracedeelafsluiting is verplicht' }]
        formItemPlaceholder: ['Begindatum','Einddatum']
        save: { attributes: ['startTracedeelafsluiting', 'eindTracedeelafsluiting'] }
        editPermissions: STANDARD
      }, {
        formItem: 'tracedeel'
        formItemLabel: 'Tracedeel'
        formItemType: 'select'
        formItemRules: [{ required: true, message: 'Tracedeel is verplicht' }]
        derivedData:
          querySource: 'tracedelen'
          queryLabelAttr: 'tracedeelnummer'
        save:
          type: 'relation'
          relationName: 'Tracedeel'
        editPermissions: STANDARD
      }, {
        formItem: 'gebeurtenis'
        formItemLabel: 'Gebeurtenis'
        formItemType: 'select'
        formItemRules: [{ required: false, message: 'Gebeurtenis is verplicht' }]
        derivedData:
          querySource: 'gebeurtenis'
          queryLabelAttr: 'identificatie'
        save:
          type: 'relation'
          relationName: 'Gebeurtenis'
        editPermissions: STANDARD
      }, {
        formItem: 'oorzaak'
        formItemLabel: 'Oorzaak'
        formItemType: 'radio'
        formItemRules: [{ required: true, message: 'Oorzaak is verplicht' }]
        config: { vertical: true }
        derivedData:
          querySource: 'oorzaak'
          queryAttr: 'name'
        save:
          type: 'relation'
          relationName: 'Oorzaak'
        editPermissions: STANDARD
      }, {
        formItem: 'status'
        formItemLabel: 'Status'
        formItemType: 'select'
        defaultValue: 'concept'
        derivedData:
          querySource: 'status'
          queryLabelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'Status'
        editPermissions: STATUS
      }, {
        formItem: 'verkeersstop'
        formItemLabel: 'Verkeersstop'
        formItemType: 'radio'
        formItemRules: [{ required: true, message: 'Verkeersstop is verplicht' }]
        options: [{ value: true, label: 'Ja' }, { value: false, label: 'Nee' }]
        editPermissions: STANDARD
      }, {
        formItem: 'aantalAfgeslotenRijstroken' # form key
        formItemLabel: 'Afgesloten rijstroken' # label
        formItemType: 'repeatable' # select box
        derivedData: # way to get the options for the thing?
          sourceField: 'tracedeel' # form field ref
          lookupAttr: 'rijstroken' # active attribute (ie status, value, name etc)
          repeatableSource: 'snelheid' # data query
          repeatableAttr: 'name' # value
        config:
          repeatItemType: 'radio'
          labelPrefix: 'Rijstrook'
          startAt: 1
          additionalOption:
            label: 'Niet afgesloten'
            value: undefined
        save:
          type: 'relation'
          relationThrough: 'SnelheidOpRijstrook|SnelheidPerRijstrook'
          relationName: 'Snelheid'
          dataAttr: 'rijstrooknummer'
        editPermissions: STANDARD
      }, {
        formItem: 'vluchtstrookBeschikbaar'
        formItemLabel: 'Vluchtstrook'
        formItemType: 'switch'
        derivedData:
          sourceField: 'tracedeel'
          querySource: 'tracedelen'
          queryAttr: 'tracedeelnummer'
          lookupAttr: 'vluchtstroken'
        config:
          onKey: 'afgesloten'
          offKey: 'niet afgesloten'
          inverseValue: true
          disabledIf:
            derived: true
            hasValue: 0
            setValue: undefined
        editPermissions: STANDARD
      }, {
        formItem: 'rijstrokenAfgesloten'
        formItemLabel: 'Afgesloten rijstroken'
        formItemType: 'repeatable'
        derivedData:
          sourceField: 'tracedeel'
          querySource: 'tracedelen'
          queryAttr: 'tracedeelnummer'
          lookupAttr: 'rijstroken'
          repeatableSource: 'snelheid'
          repeatableAttr: 'name'
        config:
          repeatItemType: 'switch'
          defaultValue: false
          startAt: 1
          onKey: 'afgesloten'
          offKey: 'niet afgesloten'
          labelPrefix: 'Rijstrook'
          mergeFields: [{
            parent: 'vluchtstrookBeschikbaar'
            mergeCondition:
              formField: 'oorzaak'
              formFieldValue: 'Correctief'
          }]
        save:
          type: 'relation'
          relationThrough: 'SnelheidOpRijstrook|SnelheidPerRijstrook'
          relationName: 'Snelheid'
          dataAttr: 'rijstrooknummer'
        mapValues: [
          { from: true, to: '0' },
          { from: false, to: undefined }
        ]
        editPermissions: STANDARD
      }]
      sequence:
        fields: ['identificatie', 'titel', 'duur', 'tracedeel', 'gebeurtenis', 'oorzaak', 'status']
        nextConditionBasedOn: 'oorzaak'
        next:
          "Preventief":
            fields: ['verkeersstop']
            nextConditionBasedOn: 'verkeersstop'
            next:
              "false":
                fields: ['aantalAfgeslotenRijstroken', 'vluchtstrookBeschikbaar']
          "Correctief":
            fields: ['rijstrokenAfgesloten', 'vluchtstrookBeschikbaar']
  }, {
    key: 'create-boetepunten-opgelegd'
    title: 'Boetepunten aanmaken'
    closeLabel: null
    component: 'sequenced_form'
    formSequence:
      createPermissions: STANDARD_CREATE
      onSave:
        confirmation: 'De boetepunt is succesvol aangemaakt'
        nodeClassName: 'boetepunten'
        nodeClassLabel: 'Boetepunten'
      queries: [{
        id: 'betaalPerioden'
        query: -> Q().hasRelationOut('rdf:type', 'betaalperiode').str()
      }, {
        id: 'boetepuntcategorie'
        query: -> Q().hasRelationOut('rdf:type', 'boetepuntcategorie').str()
      }, {
        id: 'register'
        query: -> Q().hasRelationOut('rdf:type', 'Register').str()
      }, {
        id: 'gebeurtenis'
        query: -> Q().hasRelationOut('rdf:type', 'gebeurtenis').str()
      }, {
        id: "status"
        query: -> Q().hasRelationOut("rdf:type", "ClassificatieStatus").str()
      }]
      formFields: [{
        formItem: 'identificatie'
        formItemLabel: 'Identificatie'
        formItemType: 'string'
        config: { hidden: true, incrementationPrefix: 'BP_', type: 'increment_id', disabled: true }
        editPermissions: STANDARD
      }, {
        formItem: 'omschrijving'
        formItemLabel: 'Omschrijving'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'tekortkomingOpdrachtnemer'
        formItemLabel: 'Tekortkoming opdrachtnemer ID'
        formItemType: 'string'
        formItemRules: [{ required: true, message: 'Tekortkoming opdrachtnemer ID is verplicht' }]
        editPermissions: STANDARD
      }, {
        formItem: 'boetepuntencategorienummer'
        formItemLabel: 'Boetepuntencategorienummer'
        formItemType: 'select'
        formItemRules: [{ required: true, message: 'Boetepuntencategorienummer is verplicht' }]
        derivedData:
          querySource: 'boetepuntcategorie'
          queryLabelAttr: 'boetepuntcategorieNummer'
        save:
          type: 'relation'
          relationName: 'Boetepuntcategorie'
        editPermissions: STANDARD
      }, {
        formItem: 'betaalperiode'
        formItemLabel: 'Betaalperiode'
        formItemType: 'select'
        formItemRules: [{ required: true, message: 'Betaalperiode is verplicht' }]
        derivedData:
          querySource: 'betaalPerioden'
          queryLabelAttr: 'betaalperiodeID'
        save:
          type: 'relation'
          relationName: 'Betaalperiode'
        editPermissions: STANDARD
      }, {
        formItem: 'gebeurtenis'
        formItemLabel: 'Gebeurtenis'
        formItemType: 'select'
        derivedData:
          querySource: 'gebeurtenis'
          queryLabelAttr: 'identificatie'
        save:
          type: 'relation'
          relationName: 'Gebeurtenis'
        editPermissions: STANDARD
      }, {
        formItem: 'status'
        formItemLabel: 'Status'
        formItemType: 'select'
        defaultValue: 'concept'
        derivedData:
          querySource: 'status'
          queryLabelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'Status'
        editPermissions: STATUS
      }, {
        formItem: 'referentieOG'
        formItemLabel: 'Referentie opdrachtgever'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'aantalBoetepunten'
        formItemLabel: 'Aantal boetepunten'
        formItemType: 'number'
        formItemRules: [{ required: true, message: 'Aantal boetepunten is verplicht' }]
        config: { minValue: 0 }
        editPermissions: STANDARD
      }, {
        formItem: 'herhalingskorting'
        formItemLabel: 'Herhalingskorting'
        formItemType: 'radio'
        options: [{ value: true, label: 'Ja' }, { value: false, label: 'Nee' }]
        config: { type: 'radio' }
        editPermissions: STANDARD
      }]
      sequence:
        fields: [
          'identificatie',
          'omschrijving',
          'tekortkomingOpdrachtnemer',
          'boetepuntencategorienummer',
          'betaalperiode',
          'gebeurtenis',
          'referentieOG',
          'aantalBoetepunten',
          'herhalingskorting',
          'status'
          ]
  }, {
    key: 'create-gebeurtenis'
    title: 'Gebeurtenis aanmaken'
    closeLabel: null
    component: 'sequenced_form'
    formSequence:
      createPermissions: STANDARD_CREATE
      onSave:
        confirmation: 'De gebeurtenis is succesvol aangemaakt'
        nodeClassName: 'gebeurtenis'
        nodeClassLabel: 'Gebeurtenis'
      queries: [{
        id: 'status'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieStatus').str()
      }, {
        id: 'rijstrookafsluiting'
        query: -> Q().hasRelationOut('rdf:type', 'tracedeelafsluiting').str()
      }, {
        id: 'boetepunten'
        query: -> Q().hasRelationOut('rdf:type', 'boetepunten').str()
      }, {
        id: 'workorder'
        query: -> Q().hasRelationOut('rdf:type', 'workorder').str()
      }, {
        id: 'vkms'
        query: -> Q().hasRelationOut('rdf:type', 'verkeersmaatregel').str()
      }]
      formFields: [{
        formItem: 'identificatie'
        formItemLabel: 'Identificatie'
        formItemType: 'string'
        config: { hidden: true, incrementationPrefix: 'GB_', type: 'increment_id', disabled: true }
        editPermissions: STANDARD
      }, {
        formItem: 'omschrijving'
        formItemLabel: 'Omschrijving'
        formItemType: 'string'
        formItemRules: [{ required: true, message: 'Omschrijving is verplicht' }]
        editPermissions: STANDARD
      }, {
        formItem: 'duur'
        formItemLabel: 'Duur van de gebeurtenis'
        formItemType: 'daterange'
        formItemRules: [{ required: true, message: 'Duur van de gebeurtenis is verplicht' }]
        formItemPlaceholder: ['Aanmelding','Afmelding']
        save: { attributes: ['startGebeurtenis', 'eindGebeurtenis'] }
        editPermissions: STANDARD
      }, {
        formItem: 'overeengekomenToegestaneHersteltijd'
        formItemLabel: 'Overeengekomen toegestane hersteltijd'
        formItemType: 'timeperiod'
        formItemInitialValue: 0
        editPermissions: STANDARD
      }, {
        formItem: 'tekortkomingOpdrachtnemer'
        formItemLabel: 'Tekortkoming opdrachtnemer'
        formItemType: 'radio'
        options: [{ value: true, label: 'Ja' }, { value: false, label: 'Nee' }]
        config: { type: 'radio' }
        editPermissions: STANDARD
      }, {
        formItem: 'rijstrookafsluiting'
        formItemLabel: 'Tracedeelafsluiting'
        formItemType: 'selectOrCreate'
        config:
          mode: 'multiple'
          createForm: 'create-tracedeelafsluiting'
          withoutName: true
        derivedData:
          querySource: 'rijstrookafsluiting'
          queryLabelAttr: 'identificatie'
        save:
          type: 'relation'
          orientation: "IN"
          relationName: 'Gebeurtenis'
        editPermissions: STANDARD
      }, {
        formItem: 'boetepunten'
        formItemLabel: 'Boetepunt'
        formItemType: 'selectOrCreate'
        config:
          createForm: 'create-boetepunten-opgelegd'
          withoutName: true
        derivedData:
          querySource: 'boetepunten'
          queryLabelAttr: 'identificatie'
        save:
          type: 'relation'
          orientation: "IN"
          relationName: 'Gebeurtenis'
        editPermissions: STANDARD
      }, {
        formItem: 'workorder'
        formItemLabel: 'Workorder'
        formItemType: 'selectOrCreate'
        config:
          createForm: 'create-workorder'
          withoutName: true
        derivedData:
          querySource: 'workorder'
          queryLabelAttr: 'identificatie'
        save:
          type: 'relation'
          orientation: "IN"
          relationName: 'Gebeurtenis'
        editPermissions: STANDARD
      }, {
        formItem: 'vkm'
        formItemLabel: 'Verkeersmaatregel'
        formItemType: 'selectOrCreate'
        config:
          mode: 'multiple'
          createForm: 'create-verkeersmaatregel'
          withoutName: true
        derivedData:
          querySource: 'vkms'
          queryLabelAttr: 'identificatie'
        save:
          type: 'relation'
          orientation: "IN"
          relationName: 'Gebeurtenis'
        editPermissions: STANDARD
      }, {
        formItem: 'status'
        formItemLabel: 'Status'
        formItemType: 'select'
        defaultValue: 'concept'
        derivedData:
          querySource: 'status'
          queryLabelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'Status'
        editPermissions: STATUS
      }]
      sequence:
        fields: [
          'identificatie',
          'omschrijving',
          'duur',
          'overeengekomenToegestaneHersteltijd',
          'tekortkomingOpdrachtnemer',
          'rijstrookafsluiting',
          'boetepunten',
          'workorder',
          'vkm',
          'status'
        ]
  }, {
    key: 'create-verkeersmaatregel'
    title: 'Verkeersmaatregel aanmaken'
    closeLabel: null
    component: 'sequenced_form'
    formSequence:
      createPermissions: STANDARD_CREATE
      onSave:
        confirmation: 'De verkeersmaatregel is succesvol aangemaakt'
        nodeClassName: 'verkeersmaatregel'
        nodeClassLabel: 'Verkeersmaatregel'
      queries: [{
        id: 'gebeurtenis'
        query: -> Q().hasRelationOut('rdf:type', 'gebeurtenis').str()
      }, {
        id: 'aanvraag'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieAanvraagtype').str()
      }, {
        id: 'status'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieStatus').str()
      }]
      formFields: [{
        formItem: 'identificatie'
        formItemLabel: 'Identificatie'
        formItemType: 'string'
        config: { hidden: true, incrementationPrefix: 'VM_', type: 'increment_id', disabled: true }
        editPermissions: STANDARD
      }, {
        formItem: 'spinid'
        formItemLabel: 'ID'
        formItemType: 'string'
        formItemRules: [{ required: true, message: 'ID is verplicht' }]
        editPermissions: STANDARD
      },{
        formItem: 'duur'
        formItemLabel: 'Duur van de verkeersmaatregel'
        formItemType: 'daterange'
        formItemPlaceholder: ['Starttijd','Eindtijd']
        save: { attributes: ['starttijd', 'eindtijd'] }
        editPermissions: STANDARD
      }, {
        formItem: 'gebeurtenis'
        formItemLabel: 'Gebeurtenis'
        formItemType: 'select'
        formItemRules: [{ required: false, message: 'Gebeurtenis is verplicht' }]
        derivedData:
          querySource: 'gebeurtenis'
          queryLabelAttr: 'identificatie'
        save:
          type: 'relation'
          relationName: 'Gebeurtenis'
        editPermissions: STANDARD
      }, {
        formItem: 'aanvraag'
        formItemLabel: 'Aanvraag'
        formItemType: 'select'
        derivedData:
          querySource: 'aanvraag'
          queryLabelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'typeAanvraag'
        editPermissions: STANDARD
      }, {
        formItem: 'status'
        formItemLabel: 'Status'
        formItemType: 'select'
        defaultValue: 'concept'
        derivedData:
          querySource: 'status'
          queryLabelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'Status'
        editPermissions: STATUS
      }]
      sequence:
        fields: ['identificatie', 'spinid', 'gebeurtenis', 'aanvraag', 'duur', 'status']
  }, {
    key: 'create-workorder'
    title: 'Workorder aanmaken'
    closeLabel: null
    component: 'sequenced_form'
    formSequence:
      createPermissions: STANDARD_CREATE
      onSave:
        confirmation: 'De Workorder is succesvol aangemaakt'
        nodeClassName: 'workorder'
        nodeClassLabel: 'Workorder'
      queries: [{
        id: 'gebeurtenis'
        query: -> Q().hasRelationOut('rdf:type', 'gebeurtenis').str()
      }, {
        id: 'status'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieStatus').str()
      }, {
        id: 'ssi'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieSSI').str()
      }, {
        id: 'eis'
        query: -> Q().hasRelationOut('rdf:type', 'eis').str()
      }, {
        id: 'faaldefinitie'
        query: (queryInputs) ->
          q = Q().hasRelationOut('rdf:type', 'faaldefinitie')
          if eisTarget = queryInputs['eis']
            q.hasRelationOut('eisID', eisTarget)
          q.str()
      }, {
        id: 'verificatiemethode'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieVerificatiemethode').str()
      }]
      formFields: [{
        formItem: 'identificatie'
        formItemLabel: 'Identificatie'
        formItemType: 'string'
        config: { hidden: true, incrementationPrefix: 'WO_', type: 'increment_id', disabled: true }
        editPermissions: STANDARD
      }, {
        formItem: 'omsid'
        formItemLabel: 'ID'
        formItemType: 'string'
        formItemRules: [{ required: true, message: 'ID is verplicht' }]
        editPermissions: STANDARD
      },{
        formItem: 'duur'
        formItemLabel: 'Duur van de workorder'
        formItemType: 'daterange'
        formItemPlaceholder: ['Starttijd','Eindtijd']
        save: { attributes: ['startFalen', 'eindFalen'] }
        editPermissions: STANDARD
      },{
        formItem: 'oknok'
        formItemLabel: 'OK/NOK datums'
        formItemType: 'daterange'
        formItemPlaceholder: ['NOK Datum','OK Datum']
        save: { attributes: ['nokDatum', 'okDatum'] }
        editPermissions: STANDARD
      }, {
        formItem: 'gebeurtenis'
        formItemLabel: 'Gebeurtenis'
        formItemType: 'select'
        formItemRules: [{ required: false, message: 'Gebeurtenis is verplicht' }]
        derivedData:
          querySource: 'gebeurtenis'
          queryLabelAttr: 'identificatie'
        save:
          type: 'relation'
          relationName: 'Gebeurtenis'
        editPermissions: STANDARD
      }, {
        formItem: 'ssi'
        formItemLabel: 'SSI'
        formItemType: 'select'
        derivedData:
          querySource: 'ssi'
          queryLabelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'SSI'
        editPermissions: STANDARD
      },{
        formItem: 'eis'
        formItemLabel: 'Eis'
        formItemType: 'select'
        derivedData:
          querySource: 'eis'
          queryLabelAttr: 'eisID'
        save:
          type: 'relation'
          relationName: 'Eis'
        editPermissions: STANDARD
      },{
        formItem: 'faaldefinitie'
        formItemLabel: 'Faaldefinitie'
        formItemType: 'select'
        derivedData:
          querySource: 'faaldefinitie'
          queryLabelAttr: 'faaldefintieTitel'
        save:
          type: 'relation'
          relationName: 'Faaldefinitie'
        editPermissions: STANDARD
      },{
        formItem: 'verificatiemethode'
        formItemLabel: 'Verificatiemethode'
        formItemType: 'select'
        derivedData:
          querySource: 'verificatiemethode'
          queryLabelAttr: 'Verificatie-methode'
        save:
          type: 'relation'
          relationName: 'Verificatiemethode'
        editPermissions: STANDARD
      },{
        formItem: 'status'
        formItemLabel: 'Status'
        formItemType: 'select'
        defaultValue: 'concept'
        derivedData:
          querySource: 'status'
          queryLabelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'Status'
        editPermissions: STATUS
      }, {
        formItem: 'hersteltijd'
        formItemLabel: 'Hersteltijd'
        formItemType: 'timeperiod'
        formItemInitialValue: 0
        editPermissions: STANDARD
      }, {
        formItem: 'wachtperiode'
        formItemLabel: 'Wachtperiode'
        formItemType: 'timeperiod'
        formItemInitialValue: 0
        editPermissions: STANDARD
      }]
      sequence:
        fields: ['identificatie', 'omsid', 'gebeurtenis', 'ssi', 'status', 'duur', 'hersteltijd', 'wachtperiode', 'eis', 'faaldefinitie', 'verificatiemethode', 'oknok']
  }, {
    key: 'generate-report'
    title: 'Periodieke Opgave genereren'
    component: 'generate_report'
    reportData:
      onError: 'De Periodieke Opgave kan niet gegenereerd worden vanwege een technisch probleem'
      fields: [{
        key: 'year'
        label: 'Jaar'
        type: 'select'
        options: [2019..2042]
        defaultValue: 'currentYear'
        formItemRules: [{ required: true, message: 'Jaar is verplicht' }]
      }, {
        key: 'quarter'
        label: 'Kwartaal'
        type: 'radio'
        formItemRules: [{ required: true, message: 'Kwartaal is verplicht' }]
        defaultValue: 'currentQuarter'
        options: [
          { value: 'q1', label: '1' }
          { value: 'q2', label: '2' }
          { value: 'q3', label: '3' }
          { value: 'q4', label: '4' }
        ]
      }, {
        key: 'userToDisplay'
        label: 'Vrijgegeven door'
        type: 'string'
        formItemRules: [{ required: true, message: 'Vrijgegeven door is verplicht' }]
      }, {
        key: 'statusPeriodicStatement'
        label: 'Status Periodieke Opgave'
        type: 'select'
        options: [
          { value: 'concept',     label: 'Concept'     }
          { value: 'voorbereid',  label: 'Voorbereid'  }
          { value: 'vrijgegeven', label: 'Vrijgegeven' }
          { value: 'afgekeurd',   label: 'Afgekeurd'   }
        ]
        formItemRules: [{ required: true, message: 'Vrijgegeven door is verplicht' }]
      }]
      endpoint: {
        url: 'https://gg-calculation.sysunite.nl:3434/calculate'
        params: [{
          param: 'weaver_url'
          value: 'https://hawaii.weaverplatform.com'
        }, {
          param: 'weaver_project'
          value: 'projectId'
        }, {
          param: 'weaver_user'
          value: 'authToken'
        }]
      }
    service: {
      name: 'invoice-service',
      call: 'generateInvoice',
    }
  }, {
    key: 'clear-space'
    title: 'Space wissen'
    component: 'clear_space'
  }, {
    key: 'upload-excel'
    title: 'Stamdata uploaden'
    component: 'upload_file'
    service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['raw-xl'], config: {}  }
  }, {
    key: 'upload_transformations_yaml_file'
    title: 'Stamdata transformeren'
    component: 'upload_transformations_file'
    service: { name: 'weaver-transform', call: 'transformFromFile' }
  }]
  editPages: [{
    key: 'create-betaalperiode'
    title: 'Betaalperiode NIET aanmaken'
    closeLabel: null
    component: 'sequenced_form'
    formSequence:
      createPermissions: STANDARD_CREATE
      onSave:
        confirmation: 'De betaalperiode is succesvol aangemaakt'
        nodeClassName: 'betaalperiode'
        nodeClassLabel: 'Betaalperiode'
      queries: [{
        id: 'status'
        query: -> Q().hasRelationOut('rdf:type', 'ClassificatieStatus').str()
      }]
      formFields: [{
        formItem: 'status'
        formItemLabel: 'Status'
        formItemType: 'select'
        defaultValue: 'concept'
        derivedData:
          querySource: 'status'
          queryLabelAttr: 'name'
        save:
          type: 'relation'
          relationName: 'Status'
        editPermissions: STATUS
      }, {
        formItem: 'indexgetal'
        formItemLabel: 'Indexgetal'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'indexatiecorrectie' # bedrag
        formItemLabel: 'Indexatiecorrectie'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'indexgetalOverigeBedragen'
        formItemLabel: 'Indexgetal overige bedragen'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'hinderruimtePreventief'
        formItemLabel: 'Hinderruimte preventief'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'hinderruimteVoorgaand'
        formItemLabel: 'Hinderruimte voorgaand'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'hinderruimteOpvolgend'
        formItemLabel: 'Hinderruimte opvolgend'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'hinderruimteResterend'
        formItemLabel: 'Hinderruimte resterend'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'epv'
        formItemLabel: 'EPV'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'epvBasisElektriciteitsprijs'
        formItemLabel: 'EPV Basis Elektriciteitsprijs'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'epvVerbruikVoorgaandJaar'
        formItemLabel: 'EPV verbruik voorgaand jaar'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'epvGeleverdVoorgaandJaar'
        formItemLabel: 'EPV geleverd voorgaand jaar'
        formItemType: 'string'
        editPermissions: STANDARD
      }, {
        formItem: 'epvNegatiefSaldo'
        formItemLabel: 'EPV negatief saldo'
        formItemType: 'string'
        editPermissions: STANDARD
      }]
      sequence:
        fields: [
          'status',
          'indexgetal',
          'indexatiecorrectie',
          'indexgetalOverigeBedragen',
          'hinderruimtePreventief',
          'hinderruimteVoorgaand',
          'hinderruimteOpvolgend',
          'hinderruimteResterend',
          'epv',
          'epvBasisElektriciteitsprijs',
          'epvVerbruikVoorgaandJaar',
          'epvGeleverdVoorgaandJaar',
          'epvNegatiefSaldo'
        ]
  }]
}
